import { useContext } from 'react';
import DynamicNftContext from '../contexts/DynamicNftContext';

const useDynamicNftContext = () => useContext(DynamicNftContext);

export default useDynamicNftContext;
